import React from 'react';
import RichText from '../ui/RichText';
import '../../css/common/CurrentEventCard.css';

const CurrentEventCard = ({ event, onViewSchedule }) => {
  const handleViewSchedule = (e) => {
    e.stopPropagation();
    if (onViewSchedule) {
      onViewSchedule(event.holidayId);
    }
  };

  return (
    <div className="current-event-card-component">
      <div className="current-event-card-image">
        {event.imageUrl ? (
          <img
            src={event.imageUrl}
            alt={event.title}
            onError={(e) => {
              if (e.target && e.target.style) {
                e.target.style.display = 'none';
              }
              if (e.target && e.target.nextSibling && e.target.nextSibling.style) {
                e.target.nextSibling.style.display = 'flex';
              }
            }}
          />
        ) : null}
        {!event.imageUrl && (
          <div className="current-event-card-placeholder">
            <span className="current-event-card-placeholder-icon">📅</span>
          </div>
        )}
      </div>
      <div className="current-event-card-content">
        <h3 className="current-event-card-title">{event.title}</h3>
        <div className="current-event-card-details">
          <span className="current-event-card-date">{event.date}</span>
          <span className="current-event-card-time">{event.time}</span>
        </div>
        <RichText value={event.description} className="current-event-card-description" />
        {event.holidayId && (
          <button
            onClick={handleViewSchedule}
            className="current-event-card-signup current-event-card-signup--red"
          >
            View Schedule
          </button>
        )}
        {(event.signupLink || event.ctaLink) && (
          <a
            href={event.ctaLink || event.signupLink}
            target="_blank"
            rel="noopener noreferrer"
            className="current-event-card-signup"
          >
            {event.ctaText || 'Sign Up'}
          </a>
        )}
      </div>
    </div>
  );
};

export default CurrentEventCard; 